
angular.module("prisma")
    .filter('percentage', ['$filter', function ($filter) {
        return function (input, decimals) {
            return $filter('number')(parseFloat(input) * 100, decimals) + '%';
        };
    }]);



